import { Component, EventEmitter, Input, Output } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
@Component({
	selector: 'app-optional-trip-basic',
	templateUrl: './optional-trip-basic.component.html',
	styleUrls: ['./optional-trip-basic.component.css'],
})
export class OptionalTripBasicComponent {
	@Input() data: any;
	@Input() editable = false;
	@Output() dataChanged = new EventEmitter();
	isActiveOptions = [
		{ enum: false, name: 'Nieaktywna' },
		{ enum: true, name: 'Aktywna' },
	];
	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};
}
